/* eslint-disable global-require */
// import {cloneDeep, isEqual} from 'lodash'
import {pick, cloneDeep, isEqual} from 'lodash'
// import {cloneDeep, isEqual} from 'lodash'
// import {validations} from '../../../../../mocks/customers/factory.js'
import template from './templates.pug'
import basic_template_1 from './email-templates/basic-template-1.json'
import basic_template_2 from './email-templates/basic-template-2.json'
import basic_template_3 from './email-templates/basic-template-3.json'
import basic_template_4 from './email-templates/basic-template-4.json'

const validations = {
  design: {type: 'string', required: true},
  template: {type: 'string', required: true}
}

const DefaultValues = () => Object.freeze({
  design: '', template: ''
})

const Fields = Object.keys(DefaultValues())
const Validations = pick(validations, Fields)

export default Vue.extend({
  fields: Fields,
  defaultValues: DefaultValues,
  validations: Validations,
  template: template(),
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    initErrors: {
      type: [Array, Object],
      default: () => []
    },
    disableAccordion: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: {},
      errors: [],
      showModal: false,
      templateValue: '',
      // Flag para mostrar si es necesario mostrar un error indicando que es obligatorio añadir
      // al menos una web
      siteRequiredError: false,
      ready: false,
      currentTab: 'uno',
      emailBasicsTemplates: [
        {
          id: 1,
          srcImg: false,
          title: 'En blanco',
          active: false,
          selected: false,
          html: 'without',
          design: 'without'
        },
        {
          id: 2,
          srcImg: require('assets/images/email-templates/basic-template-1.svg'),
          title: 'Basic Template 1',
          active: false,
          selected: false,
          html: basic_template_1.template,
          design: basic_template_1.design
        },
        {
          id: 3,
          srcImg: require('assets/images/email-templates/basic-template-2.svg'),
          title: 'Basic Template 2',
          active: false,
          selected: false,
          html: basic_template_2.template,
          design: basic_template_2.design
        },
        {
          id: 4,
          srcImg: require('assets/images/email-templates/basic-template-3.svg'),
          title: 'Basic Template 3',
          active: false,
          selected: false,
          html: basic_template_3.template,
          design: basic_template_3.design
        },
        {
          id: 5,
          srcImg: require('assets/images/email-templates/basic-template-4.svg'),
          title: 'Basic Template 4',
          active: false,
          selected: false,
          html: basic_template_4.template,
          design: basic_template_4.design
        }
      ]
    }
  },
  watch: {
    // cada vez que se cambia el data emitimos el valor para mantener el v-model actualizado
    data: {
      deep: true,
      handler(_newVal, oldVal) {
        // con el if evitamos que se emita la primera vez cuando se inicializa
        if (oldVal) this.$emit('input', {...this.data})
      }
    },

    value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        // Solo se debe de ejecutar cuando se produce un cambio
        if (isEqual(newValue, this.data)) return

        this.initializeData()
      }
    },

    initErrors: {
      deep: true,
      immediate: true,
      handler() {
        if (!this.initErrors.sites) return

        // gestionamos el error: "sites: required"
        if (this.initErrors.sites instanceof Array) {
          this.errors = cloneDeep(this.initErrors)
          this.siteRequiredError = false
        } else {
          this.errors = []
          this.siteRequiredError = true
        }
      }
    }
  },
  methods: {
    activeModal(html) {
      this.showModal = true
      this.templateValue = html
    },
    closeModal() {
      this.showModal = false
    },
    checkSelected(id) {
      // eslint-disable-next-line no-shadow
      this.emailBasicsTemplates.forEach(template => {
        if (template.id === id) {
          if (template.selected) {
            this.data.template = ''
            this.data.design = ''
            template.selected = false
          } else {
            template.selected = true
            this.data.template = template.html
            this.data.design = template.design
          }
        } else {
          template.selected = false
        }
      })
    },
    selectTemplate(id) {
      // eslint-disable-next-line no-shadow
      this.emailBasicsTemplates.forEach(template => {
        if (template.id === id) {
          template.active = true
        } else {
            template.active = false
        }
      })
    },
    change(id, _n) {
      this.currentTab = id

      // if (id === 'dos') {
      //   this.$nextTick(() => {
      //     this.currentTab = 'uno'
      //   })
      // }
    },
    initializeData() {
      // this.data = this.emailBasicsTemplates
      const data = {}
      Fields.forEach(key => { data[key] = this.value ? this.value[key] : '' })
      this.data = data
      this.ready = true
    },

    t(key, options = {}) {
      return this.$t(`customers.form.${key}`, options)
    },

    addSite() {
      this.data.sites.push({url: '', description: ''})
    },

    deleteSite(index) {
      this.data.sites.splice(index, 1)
    }
  }
})
